





























import { Component, Vue } from "vue-property-decorator";
import { Carousel, Modal } from "ant-design-vue";
import CTabs from "../cTabs.vue";

@Component({
  name: "CService",
  components: {
    CTabs,
    AModal: Modal,
    ACarousel: Carousel
  }
})
export default class MyService extends Vue {
  private tabIndex = 0;
  private qrcodeModal = false;
  private qrcodeImg = "";
  private dataSource: any[] = [];
  // 一页显示几个项目
  private carouselStep = 6;

  private async created() {
    await Promise.all([this.$api.IntservWeChatList(), this.$api.IntservLink()]).then((res: any[]) => {
      if (res[0] && res[0].code === 200) {
        this.dataSource = [...this.dataSource, ...res[0].data];
      }

      if (res[1] && res[1].code === 200) {
        this.dataSource = [...this.dataSource, ...res[1].data];
      }
    });
  }

  private get list() {
    const step = this.carouselStep;
    const _return: any[] = Array.from({ length: Math.ceil(this.dataSource.length / step) }, () => []);
    for (let i = 0; i < _return.length; i++) {
      for (let j = i * step; j < i * step + step; j++) {
        if (this.dataSource[j]) {
          _return[i].push(this.dataSource[j]);
        } else {
          break;
        }
      }
    }
    return _return;
  }

  private tabsClick(e: Common.CTabsEmit) {
    this.tabIndex = e.activeIndex;
  }

  private openQrcode(path: string) {
    if (path) {
      this.qrcodeImg = "";
      this.$nextTick(() => {
        this.qrcodeModal = true;
        this.qrcodeImg = path;
      });
    } else {
      this.$message.warning("二维码图片地址是空的");
    }
  }
}
